import FragmentDataType from "../enums/fragment-data-type";
import { FragmentMessages } from "../../common/fragment-messages";
import FumbledSnapRecovered from "./fumbled-snap-recovered";

export default class FumbledSnapLost extends FumbledSnapRecovered {
    constructor(recoveredBy, recoveredAt) {
        super();
        this.recoveredBy = recoveredBy;
        this.recoveredAt = recoveredAt;

        this.requiredData = [
            {
                name: "recoveredBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => true,
                displayName: "Recovered By",
                title: (team) => `Recovered By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            },
            {
                name: "recoveredAt",
                type: FragmentDataType.FieldPosition,
                displayName: "Recovered At",
                title: "At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                showEndZoneYards: (gameConfig) =>
                    gameConfig.general.includeEndZoneYardage
            }
        ];
    }
}
